/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/barcode-lookup-plans/actions';
import { getAllBarcodeLookupPlans, requestingBarcodeLookupPlans } from 'state/barcode-lookup-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentBarcodeLookupId, getCurrentBarcodeLookupPlanId, getCurrentBarcodeLookup } from 'state/current-barcode-lookup/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentBarcodeLookup } from 'state/current-barcode-lookup/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectBarcodeLookupPlan = (props) => {
    const barcodeLookupPlans = props.barcodeLookupPlans;
    const [submitting, setSubmitting] = useState(false);

    const onChange = (value) => {
        if (!props.barcodeLookupSubscriptionId) {
            return newPlanSubscription(value);
        }

        let plan = find(barcodeLookupPlans, { id: value });
        let addon = resolveLicenseAddon(plan);
    };

    useEffect(() => {
        props.requestBarcodeLookupPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.barcodeLookupSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Barcode Lookup Module subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            // close: () => { window.location.reload(); },
            success: () => {
                props.requestCurrentBarcodeLookup();
                props.successNotice('Your Barcode Lookup Module subscription has been created.');
                page.redirect('/dashboard/barcode-lookup');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {barcodeLookupPlans.map((plan, i) => {
                        return (
                            <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentBarcodeLookup && props.currentBarcodeLookup.status == 'cancelled')
                                        ? plan.id == props.barcodeLookupPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        barcodeLookupPlans: getAllBarcodeLookupPlans(state),
        addons: getAllAddons(state),
        barcodeLookupSubscriptionId: getCurrentBarcodeLookupId(state),
        barcodeLookuplanId: getCurrentBarcodeLookupPlanId(state),
        currentBarcodeLookup: getCurrentBarcodeLookup(state),
        currentUser: getCurrentUser(state),
        requesting: requestingBarcodeLookupPlans(state),
    }),
    {
        requestBarcodeLookupPlans: requestPlansIfNotRequested,
        requestCurrentBarcodeLookup,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectBarcodeLookupPlan);
